import React, { useEffect, useState, useRef } from "react";
import styles from "./Home.module.scss";
import CardBanner from "components/Card/ExamSet/CardBanner";
import { CriterionRandomQuestionModal } from "components/CriterionRandomQuestionModal";
import useAuth from "context/auth";
import HomeSubjectList from "./HomeSubjectList";
import LevelMenu from "components/LevelMenu/LevelMenu";
import { Button, Modal, Spin, Flex, Carousel, Skeleton } from "antd";
import { getTestFromDisconnect } from "services/testing/action/actionStartTesting";
import { TranslateLanguage } from "util/Translate";
import { vocabHome } from "util/Translate.variable";
import HomePublisher from "./HomePublisher";
import { useDataStore } from "store/DataStoreContext";
import useWindowSize from "hook/useWindowSize";
import { actionType } from "store/dataReducer";
import HomeBundle from "./HomeBundle";
import HomePretest from "./Components/Pretest/HomePretest";
import _ from "lodash";
import useComponentDimension from "util/useComponentDimension";
import { checkAndUpdateToken } from "util/checkAndUpdateToken";
import {
  clearLocalStorage,
  getLocalStorage,
  setLocalStorage,
} from "util/localstorage";
import { IoIosWarning } from "react-icons/io";
import ModalTimeCorrection from "../TimeCorrection/ModalTimeCorrect";

const translate = new TranslateLanguage();
translate.addMaping(vocabHome);

const useDebouncedLoading = (initialLoading, delay) => {
  const [debouncedLoading, setDebouncedLoading] = useState(initialLoading);

  useEffect(() => {
    let timeoutId;

    if (initialLoading) {
      setDebouncedLoading(true);
    } else {
      timeoutId = setTimeout(() => {
        setDebouncedLoading(initialLoading);
      }, delay);
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [initialLoading, delay]);

  return debouncedLoading;
};

const Home = (props) => {
  const {
    state: { user, isLoading },
  } = useAuth();
  const [ref, dimensions] = useComponentDimension();
  const iframeRef = useRef(null);

  const [level, setLevel] = useState();
  // eslint-disable-next-line no-unused-vars
  const [isModalStep, setIsModalStep] = useState(false);
  const [gradeStep, setGradeStep] = useState([]);
  const [examTypeDetail, setExamTypeDetail] = useState(null);
  const [openWaitFinish, setOpenWaitFinish] = useState(false);
  const [currentGrade, setCurrentGrade] = useState();
  const [activeLevel, setActiveLevel] = useState("");
  const [isTimeCorrect, setIsTimeCorrect] = useState(false);

  const {
    state: { educationType, publisher, bundle, pretest },
    dispatch,
    loading,
  } = useDataStore();

  const debouncedLoading = useDebouncedLoading(loading, 300);
  const { width } = useWindowSize();

  if (window?.ResizeObserver) {
    window.ResizeObserver = undefined;
  }

  useEffect(() => {
    const from = getLocalStorage("page");
    clearLocalStorage("page");

    if (from?.page === "landing") {
      props.history.push("/landingform", { from: from.ex1 });
    }

    localStorage.removeItem("dataStartTesting");
    localStorage.removeItem("startAt");
    if (window.navigator?.onLine) {
      localStorage.removeItem("homePage");
      localStorage.removeItem("internet");
    }
    if (localStorage.getItem("waitForFinish")) {
      setOpenWaitFinish(true);
    }

    const initCheckAndUpdateToken = async () => {
      await checkAndUpdateToken();
    };

    initCheckAndUpdateToken();
    window.scrollTo(0, 0);
  }, []);

  const handleToggleTimeStatus = () => {
    setIsTimeCorrect((prev) => !prev);
  };

  const TimeFunction = () => {
    const timeData = getLocalStorage("time-incorrect");
    setIsTimeCorrect(timeData);
  };

  useEffect(() => {
    TimeFunction();
  }, [getLocalStorage("time-incorrect")]);

  useEffect(() => {
    initial();
  }, [debouncedLoading]);

  const initial = () => {
    let levelSet = "";
    if (user) {
      setCurrentGrade(user.grade);
      if (user.grade) {
        if (user.grade <= 6) {
          setActiveLevel("ElementarySchool");
        } else {
          setActiveLevel("JuniorHighSchool");
        }
      }
    }
  };

  const onChangeLevel = (level) => {
    if (level !== activeLevel) {
      setActiveLevel(level);
      dispatch({
        type: actionType.CHANGE_LEVEL,
        payload: level,
      });
    }
  };

  const getDefaultGrade = () => {
    if (["เตรียมสอบเข้า ม.1", "O-NET"].includes(examTypeDetail?.examTypeName)) {
      return "6";
    }
    if (!user) return "1";
    return user.grade.toString();
  };

  const checkInternet = () => {
    return {
      button:
        localStorage.getItem("internet") === "disconnected"
          ? translate.convert("รอการเชื่อมต่อ")
          : translate.convert("ตกลง"),
      disconnect: localStorage.getItem("internet") === "disconnected",
    };
  };
  if (window.navigator?.onLine) {
    window.addEventListener("offline", (e) => {
      if (
        window.location.pathname === "/" ||
        window.location.pathname === "/home"
      ) {
        localStorage.setItem("homePage", "disconnected");
        props.history.push("/");
      }
    });
  }
  if (window.navigator?.onLine) {
    window.addEventListener("online", (e) => {
      if (
        window.location.pathname === "/" ||
        window.location.pathname === "/home"
      ) {
        if (localStorage.getItem("homePage") === "disconnected") {
          localStorage.removeItem("homePage", "disconnected");
          props.history.push("/");
        }
      }
    });
  }

  return (
    <>
      {debouncedLoading ? (
        <div
          style={{
            display: "flex",
            margin: "auto",
            width: "100%",
            height: "100%",
          }}
        >
          <Spin size={"large"} fullscreen={true} style={{ margin: "auto" }} />
        </div>
      ) : (
        <div className={styles.rootHome} ref={ref}>
          <CardBanner {...props} />
          <div
            className={styles.inner_circle}
            style={
              width < 800
                ? width > 400
                  ? { margin: "1rem" }
                  : { margin: ".6rem" }
                : {}
            }
          >
            {educationType.loading ? (
              <>
                <Skeleton.Input
                  active={true}
                  style={{
                    margin: "24px 0 24px 0",
                    height: "64px",
                    width: dimensions.width,
                  }}
                />
              </>
            ) : (
              <LevelMenu
                menuList={educationType.data}
                amountItem={4}
                activeMenu={activeLevel}
                onClick={onChangeLevel}
              />
            )}
            <HomeBundle onCLickLoadMore={() => props.history.push("/bundle")} />
            <HomePretest
              onCLickLoadMore={() => props.history.push("/pretest")}
            />
            <HomeSubjectList {...props} level={activeLevel} />
            <HomePublisher
              {...props}
              publisher={publisher}
              level={activeLevel}
            />
          </div>
          {isModalStep && (
            <CriterionRandomQuestionModal
              visible={isModalStep}
              onClose={() => setIsModalStep(false)}
              startAtStep={1}
              grades={gradeStep}
              hideStepLesson={["42dd394d-11df-4764-9dd5-8515c660bb08"].includes(
                examTypeDetail?.examTypeId
              )}
              defaultGrade={getDefaultGrade()}
              examTypeDetail={examTypeDetail}
              defaultStep={null}
              history={props.history}
            />
          )}
          {openWaitFinish && (
            <Modal
              visible={openWaitFinish}
              centered
              footer={false}
              closeIcon={<div></div>}
            >
              <div className={styles.container}>
                <h4 className={styles.title}>
                  {translate.convert("เกิดปัญหาสัญญาอินเทอร์เน็ตขณะส่งข้อสอบ")}
                </h4>
                <span className={styles.content_text}>
                  {translate.convert("กดปุ่มตกลงเพื่อส่งข้อสอบ")}
                </span>
                <div className={styles.button_group}>
                  <Button
                    type="primary"
                    onClick={(e) => getTestFromDisconnect(props)}
                    disabled={checkInternet().disconnect}
                  >
                    {" "}
                    {checkInternet().button}{" "}
                  </Button>
                </div>
              </div>
            </Modal>
          )}
          {isTimeCorrect && (
            <ModalTimeCorrection
              isTimeCorrect={isTimeCorrect}
              handleToggleTimeStatus={handleToggleTimeStatus}
            />
          )}
        </div>
      )}
    </>
  );
};
export default Home;
